<template>
  <r-panel :title="title">
    <v-card width="100%" class="ma-0 pa-2" elevation="0" outlined>
      <v-card-title class="pa-0 ma-0 ml-1 mb-2">Config</v-card-title>
      <v-row dense class="pb-2 ma-0 pa-2">
        <v-col cols="12" md="5" sm="5">
          <v-row dense>
            <r-currency-kind-dropdown :model.sync="value.currency" label="Track Currency"/>
          </v-row>
          <v-row dense v-if="payable && model" class="pt-2">
            <r-product-dropdown :model.sync="model.product" :groups="product_groups" label=" Track Product"/>
          </v-row>
        </v-col>
        <v-col cols="12" md="7" sm="7">
          <v-checkbox v-model="value.resetOnComplete" class="mx-4 mt-4" label="Reset on Complete" hide-details/>
        </v-col>
      </v-row>
    </v-card>
    <v-card width="100%" class="ma-0 pa-2 mt-3" elevation="0" outlined>
      <v-row dense class="pt-2">
        <r-reward-bunch-table :model.sync="value.reward" :points="true" label="Reward"/>
      </v-row>
    </v-card>
    <v-card width="100%" class="ma-0 pa-2 mt-3" elevation="0" outlined v-if="reminder">
      <v-card-title class="pa-0 ma-0 ml-1 mb-2">Reminder</v-card-title>
      <v-row dense class="pb-2 ma-0 pa-2">
        <v-select
            v-model="value.reminder"
            :items="reminderItems"
            item-text="name"
            item-value="id"
            label="Reminder"
            multiple
        >
          <template v-slot:selection="{ parent, item, index }">
            <v-chip v-if="index < 3">
              <span>{{ item.name }}</span>
            </v-chip>
            <span v-if="index === 3" class="grey--text text-caption">
                            (+{{ parent.selectedItems.length - 3 }} others)
            </span>
          </template>
        </v-select>
      </v-row>
    </v-card>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";
import RRewardBunchTable from "@/modules/redactor/views/reward/r-reward-bunch-table.vue";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";


export default {
  name: "r-reward-track-panel",
  components: {RProductDropdown, RRewardBunchTable, RCurrencyKindDropdown, RPanel},
  props: {
    title: VueTypes.string.def("Reward Track"),
    model: VueTypes.instanceOf(RewardTrack),
    payable: VueTypes.bool.def(false),
    reminder: VueTypes.bool.def(false)
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new RewardTrack();
        this.$emit("update:model", value);
        return value;
      }
    },
    reminderItems() {
      let items = [];

      if (this.value.reward) {
        for (let index = 0; index < this.value.reward.count; index++) {
          items.push({"name": "Reward " + index, id: index});
        }
      }

      return items;
    },
    product_groups() {
      return [ProductGroupKind.SMART_OFFERS];
    }
  }
}
</script>